import { FC } from 'react';
import { IUser } from '../../../types/auth.types';
import { Image, Text, TouchableOpacity, View } from 'react-native';
import { COLORS, FONTS } from '../../../constants';

export const UserItem: FC<{
  user: IUser;
  handleCreateChat: (id: number) => void;
  isOnline?: boolean;
}> = ({ user, handleCreateChat, isOnline = false }) => {
  return (
    <TouchableOpacity
      onPress={() => {
        handleCreateChat(user.id);
      }}
      style={{
        paddingHorizontal: 15,
        paddingVertical: 10,
        borderBottomWidth: 1,
        borderBottomColor: COLORS.LGREY,
        flexDirection: 'row',
      }}
    >
      <Image
        source={{ uri: user.avatar_url }}
        style={{
          width: 45,
          height: 45,
          borderRadius: 45,
          marginRight: 10,
        }}
      />
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'flex-start',
          gap: 6,
        }}
      >
        <Text
          style={{
            color: COLORS.BLACK,
            fontSize: 14,
            fontFamily: FONTS.AvenirRegular,
          }}
          numberOfLines={1}
        >
          {`${user.first_name} ${user.last_name}`}
        </Text>
        {isOnline && (
          <View
            style={{
              backgroundColor: COLORS.LIGHT_GREEN,
              width: 10,
              height: 10,
              borderRadius: 10,
              marginTop: 5,
            }}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};
